import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import SAlert from "components/Alert"
import useSearch from "hooks/useSearch"
import ProvinceDistributionActionRequestComponent from "components/ProvinceActionRequests/Distributions/lists"
import {
  getProvinceDistributionActionRequests,
  sendProvinceDistributionActionRequests,
} from "store/province-action-requests/province-action-request-action"
import {
  getProviderIps,
  getProviderItemCategories,
  getProviderProjects,
  getProviderProvinces,
} from "store/provider-dashboard/provider-dashboard-action"
import ProvinceOutDetailModal from "components/ProvinceOut/Details"

const ProvinceDistributionActionRequestList = () => {
  // Meta Title
  document.title = "Request For Deletion"

  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(
    state => state.provinceActionRequest
  )
  const [deleteModal, setDeleteModal] = useState(false)
  const [proOut, setProOut] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const [detailModal, setDetailModal] = useState(false)

  // Handle multiple delete action when top delete button is clicked
  const onAllDeleteClicked = ids => {
    if (ids.length > 0) {
      dispatch(sendProvinceDistributionActionRequests(ids, "Delete"))
    } else {
      SAlert({ text: "no receipt selected", status: "info" })
    }
  }

  // Handle cancel action for multiple delete when cancel button is clicked
  const onCancelDeleteClicked = ids => {
    if (ids.length > 0) {
      dispatch(sendProvinceDistributionActionRequests(ids, "Cancel"))
    } else {
      SAlert({ text: "no receipt selected", status: "info" })
    }
  }

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getProvinceDistributionActionRequests(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getProvinceDistributionActionRequests(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  // fetch new data based page number or according changes
  useEffect(() => {
    dispatch(
      getProvinceDistributionActionRequests(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  // fetch data which is needed for fitler select box
  useEffect(() => {
    dispatch(getProviderItemCategories())
    dispatch(getProviderProvinces())
    dispatch(getProviderIps())
    dispatch(getProviderProjects())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getProvinceDistributionActionRequests(
        undefined,
        undefined,
        undefined,
        search,
        data
      )
    )
  }

  // Show record details in a modal when the detail button is clicked
  const onClickDetail = data => {
    setProOut(data)
    setDetailModal(true)
  }

  return (
    <React.Fragment>
      {/* Modal For Record Detail  */}
      <ProvinceOutDetailModal
        open={detailModal}
        setOpen={setDetailModal}
        data={proOut}
      />
      <Breadcrumbs
        title={"Provider"}
        breadcrumbItem={"Distribution Request For Action"}
      />
      {/* Province Distributino Action Request List Component */}
      <ProvinceDistributionActionRequestComponent
        data={data}
        error={error}
        loading={loading}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAllDeleteClicked={onAllDeleteClicked}
        onCancelDeleteClicked={onCancelDeleteClicked}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onClickDetail={onClickDetail}
      />
    </React.Fragment>
  )
}

export default ProvinceDistributionActionRequestList
